/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaPlayerTeam = {
    properties: {
        team: {
            type: 'TeamSmall',
            isRequired: true,
        },
        position: {
            type: 'PlayerPosition',
            isRequired: true,
        },
        player: {
            type: 'FantaPlayer',
            isRequired: true,
        },
        match: {
            type: 'any-of',
            contains: [{
                type: 'FantaMatch',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
